<script setup lang="ts">
import {
  CfgButton,
  CfgDialog,
  CfgModalSizes,
  CfgTypography,
  CfgTypographySizes,
} from '@cfgtech/ui'
import { useVModel } from '@vueuse/core'

const props = defineProps<{
  modelValue: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const isOpened = useVModel(props, 'modelValue', emit)

function closeDialog() {
  isOpened.value = false
}
</script>

<template>
  <CfgDialog
    v-model:opened="isOpened"
    :size="CfgModalSizes.Large"
    @close-click:backdrop="closeDialog"
    @close-click:button="closeDialog"
  >
    <template #title>
      <CfgTypography :size="CfgTypographySizes.h2">
        {{ $t('investment.tax.title') }}
      </CfgTypography>
    </template>

    <template #description>
      <CfgTypography :size="CfgTypographySizes.md">
        <p v-html="$t('investment.tax.description')" />
      </CfgTypography>
    </template>

    <CfgButton
      class="w-full"
      variant="primary"
      @click.prevent="closeDialog"
    >
      {{ $t('common.close') }}
    </CfgButton>
  </CfgDialog>
</template>
